import { useQuery } from "@tanstack/react-query"
import { DeviceFamilyGet } from "../app/models/DeviceFamily"
import { digitalManagerApi } from "../services/api"

export function useDeviceFamilies() {
  const { data: deviceFamiliesList = [], isLoading: isLoadingDeviceFamilies } = useQuery({
    queryKey: ["deviceFamilies"],
    queryFn: () =>
      digitalManagerApi.get<DeviceFamilyGet[]>(`/deviceFamilies`).then((r) => r.data),
  })

  return {
    deviceFamiliesList,
    isLoadingDeviceFamilies,
  }
}
